/**
 * Resolves Magnolia CMS asset references to full URLs
 *
 * Handles multiple input formats:
 * - Full URLs (http:// or https://) are returned unchanged
 * - UUIDs with jcr: prefix are converted to DAM URLs
 * - Plain UUIDs are prefixed with jcr: and converted to DAM URLs
 *
 * @param assetRef - Full URL or UUID (with/without jcr: prefix)
 * @returns Full DAM URL for the asset
 *
 * @example
 * // Full URL - returned unchanged
 * resolveMagnoliaAssetUrl('https://example.com/image.png')
 * // => 'https://example.com/image.png'
 *
 * @example
 * // UUID with jcr: prefix
 * resolveMagnoliaAssetUrl('jcr:b5eaa46f-4be8-40c6-91a7-80bcb15197be')
 * // => 'https://[MGNL_HOST]/dam/jcr:b5eaa46f-4be8-40c6-91a7-80bcb15197be'
 *
 * @example
 * // Plain UUID
 * resolveMagnoliaAssetUrl('b5eaa46f-4be8-40c6-91a7-80bcb15197be')
 * // => 'https://[MGNL_HOST]/dam/jcr:b5eaa46f-4be8-40c6-91a7-80bcb15197be'
 */
export function resolveMagnoliaAssetUrl(assetRef: string): string {
  // If already a full URL, return as-is
  if (assetRef.startsWith("http://") || assetRef.startsWith("https://")) {
    return assetRef;
  }

  // If it's a UUID (with or without jcr: prefix), construct the DAM URL
  const uuid = assetRef.startsWith("jcr:") ? assetRef : `jcr:${assetRef}`;
  return `${process.env.NEXT_PUBLIC_MGNL_HOST}/dam/${uuid}`;
}
